import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services/api.service';
import {environment} from '../../../environments/environment';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';
import { ApplicationFeatures } from '../models';

@Injectable({
  providedIn: 'root'
})
export class ApplicationFeaturesService{
    constructor(
        private http: HttpClient,
        private apiService: ApiService
    ) { }

   
     /**
    * This method is used to get the search results of Application Features
    * based on the parameters.
    *
    * @param  pageNo  current page number
    * @param  pageSize Number of records per page
    * @param  sortField field needed to sort
    * @param  sortOrder whether the sorting field is ascending or descending
    * @param  appliedFilters appliedFilters
    * @return      json result
    */
      public searchApplicationFeatures(pageNo:number,pageSize:number,sortField:string,sortOrder:string,appliedFilters:{field:string,matchMode:string,value:string}[]=[]):Observable<any> {
        return this.apiService.get(`ApplicationFeatures/SearchApplicationFeatures?pageNo=${pageNo}&pageSize=${pageSize}&sortField=${sortField}&sortOrder=${sortOrder}&appliedFilters=${appliedFilters}`)
      }
  
  
      /**
      * This method is used to get all Application Features records, there is no parameter
      *
      * @return      json result
      */
       public getAllApplicationFeatures(applicationFeaturesSearchParam:IGlobalSearchParam):Observable<any> {
        console.log(applicationFeaturesSearchParam);
        return this.apiService.post(`ApplicationFeatures/SearchApplicationFeatures`,applicationFeaturesSearchParam)
      }
  
      /**
      * This method is used to get individual Application Features record based on the featureId
      *
      * @param  featureId  
      * @return      json result
      */
       public getApplicationFeaturesById(featureId:number):Observable<any> {
          return this.apiService.get(`ApplicationFeatures/${featureId}`)
      }
  
      /**
      * This method is used to post/add new Application Features record
      *
      * @param  ApplicationFeatures object which contains the ApplicationFeatures record values
      * @return      json result
      */
       public postApplicationFeatures(applicationFeatures:ApplicationFeatures):Observable<any> {
          return this.apiService.post(`ApplicationFeatures`, applicationFeatures)
      }
  
  
      /**
      * This method is used to update the existing Application Features record
      *
      * @param  feature Id 
      * @param  ApplicationFeatures object which contains the ApplicationFeatures record values
      * @return      json result
      */
       public updateApplicationFeatures(featureId:number, applicationFeatures:ApplicationFeatures):Observable<any> {
          return this.apiService.put(`ApplicationFeatures/${featureId}`, applicationFeatures)
      }
  
  
      /**
      * This method is used to delete the existing Application Features record
      *
      * @param  feature Id
      * @return      json result
      */
       public deleteApplicationFeatures(featureId:number):Observable<any> {
          return this.apiService.delete(`ApplicationFeatures/${featureId}`)
      }

      public ExportFeaturesResult(featuresSearchParam:IGlobalSearchParam):Observable<any> {
        return this.http.post(`${environment.apiRoot}ApplicationFeatures/ExportFeatures`, featuresSearchParam,
        {  
            responseType: 'blob',
            observe: 'response'
         });
      }
  
}
